<template>
  <div>
    <BudgetLimits
      v-model="budgetHourly"
      class="mt-1"
      type="budget_hourly"
      :validation-key="FeedValidationErrorsKey"
      @update:modelValue="update"
      @remove="remove"
    />
    <BudgetLimits
      v-model="budgetDaily"
      class="mt-1"
      type="budget_daily"
      :validation-key="FeedValidationErrorsKey"
      @update:modelValue="update"
      @remove="remove"
    />
    <BudgetLimits
      v-model="budgetTotal"
      class="mt-1"
      type="budget_total"
      :validation-key="FeedValidationErrorsKey"
      @update:modelValue="update"
      @remove="remove"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import BudgetLimits from '@/components/BudgetLimits.vue'
import {
  computedForCampaignLimits,
  defineUpdateCampaignLimits,
  defineRemoveCampaignLimits
} from '@/utils/limits'
import { FeedValidationErrorsKey } from '@/api/types'

export default defineComponent({
  name: 'FeedLimits',
  components: {
    BudgetLimits
  },
  props: {
    modelValue: {
      type: Array,
      default: () => []
    }
  },
  setup(props, context) {
    const budgetHourly = computed(
      computedForCampaignLimits('budget_hourly', props)
    )
    const budgetDaily = computed(
      computedForCampaignLimits('budget_daily', props)
    )
    const budgetTotal = computed(
      computedForCampaignLimits('budget_total', props)
    )

    const update = defineUpdateCampaignLimits(props, context)
    const remove = defineRemoveCampaignLimits(props, context)

    return {
      budgetHourly,
      budgetDaily,
      budgetTotal,
      update,
      remove,
      FeedValidationErrorsKey
    }
  }
})
</script>
